export default __webpack_public_path__ + "static/media/wgew.daef0547.mp3";